import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyBottomBar } from './components/StickyBottomBar';
const SocialProofStats = lazy(() => import('./components/SocialProofStats').then(m => ({
  default: m.SocialProofStats
})));
const MiniTestimonials = lazy(() => import('./components/MiniTestimonials').then(m => ({
  default: m.MiniTestimonials
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const TriangleSection = lazy(() => import('./components/TriangleSection').then(m => ({
  default: m.TriangleSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const CostOfInaction = lazy(() => import('./components/CostOfInaction').then(m => ({
  default: m.CostOfInaction
})));
const PricingTable = lazy(() => import('./components/PricingTable').then(m => ({
  default: m.PricingTable
})));
const PackCompletoExplainer = lazy(() => import('./components/PackCompletoExplainer').then(m => ({
  default: m.PackCompletoExplainer
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Facebook Pixel - manual injection
    const pixelId = '1287603379450199';
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // Facebook domain verification meta tag
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'l938w3cbwwi31gbhepzzrg02olc8cy';
    document.head.appendChild(meta);
  }, []);
  return <div className="w-full min-h-screen bg-brand-bg text-brand-text font-sans" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <AnnouncementBar data-id="element-2" />
      <HeroSection data-id="element-3" />

      <Suspense fallback={null} data-id="element-4">
        <SocialProofStats data-id="element-5" />
        <MiniTestimonials data-id="element-6" />
        <PainSection data-id="element-7" />
        <MechanismSection data-id="element-8" />
        <TriangleSection data-id="element-9" />
        <ProductSection data-id="element-10" />
        <BonusSection data-id="element-11" />
        <PricingTable data-id="element-12" />
        <PackCompletoExplainer data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <TestimonialsSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <FAQSection data-id="element-17" />
        <FinalCTA data-id="element-18" />
        <Footer data-id="element-19" />
      </Suspense>

      <StickyBottomBar data-id="element-20" />
    </div>;
}